<template>
  <div v-if="!isPublic" class="w-100 justify-space-between d-flex flex-column h-100">
    <div></div>
    <div class="d-flex w-100 flex-column gap-xs">
      <ion-img
        :src="imageOptions[type as keyof typeof imageOptions]"
        alt="Welcome Hero"
        class="principal-welcome-image mb-lg"
      ></ion-img>
      <h1 class="font-lg">{{ t(`${type}.youHaveFinishedCheck`) }}</h1>
      <p class="font-sm align-start">
        {{ t(`${type}.finishDescription`) }}
      </p>
    </div>
    <ion-button
      @click="router.replace({ name: 'MyStay' })"
      fill="solid"
      expand="block"
      size="large"
      color="accent"
      class="text-lg text-weight-bold w-100"
    >
      {{ t(`${type}.goToArribo`) }}
    </ion-button>
  </div>
  <div v-else class="w-100 justify-space-between d-flex flex-column h-100">
    <div></div>
    <div class="d-flex w-100 flex-column gap-xs">
      <ion-img
        :src="imageOptions[type as keyof typeof imageOptions]"
        alt="Welcome Hero"
        class="principal-welcome-image mb-lg"
      ></ion-img>
      <h1 class="font-lg">{{ t(`${type}.youHaveFinishedCheck`) }}</h1>
      <p class="font-sm align-start">
        {{ t(`${type}.finishDescription`) }}
      </p>
    </div>
    <div></div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import router from '@/router';
  import { IonButton, IonImg } from '@ionic/vue';
  import finishCheck from '@/assets/images/finishCheck.png';
  import finishOut from '@/assets/images/finishOut.png';
  import { storeToRefs } from 'pinia';
  import { useCheckInStore } from '@/stores/checkin-store';

  const { isPublic } = storeToRefs(useCheckInStore());

  withDefaults(
    defineProps<{
      type: string;
    }>(),
    {},
  );

  const { t } = useI18n();
  const imageOptions = {
    'check-in': finishCheck,
    'check-out': finishOut,
  };
</script>

<style lang="css">
  .principal-welcome-image {
    width: 100%;
    max-height: 328px;
    height: 100%;
    object-fit: contain;
  }
</style>
